import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { LocalStorageService, StorageKeys } from '@shared/services/local-storage/local-storage.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private localStorageService: LocalStorageService) {}

  canActivate(): boolean {
    const token = this.localStorageService.getItem(StorageKeys.AccessToken);
    const user = this.localStorageService.getItem(StorageKeys.UserInfo);

    if (!token || !user) {
      this.localStorageService.clear();
      this.router.navigate(['/auth/login'], { replaceUrl: true });
      return false;
    }

    return true;
  }
}
